
import { combineReducers } from 'redux';

import showPurchaseDetail from './showPurchaseDetail';

export default combineReducers({
  showPurchaseDetail,
});
